import React, { useContext } from 'react';
import { useLocation, Link } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';
import RouteUtils from '../../modules/routeUtils';
import { useFetchDeletionStatusQuery } from '../../redux/slices/truckSlice';

// Components
import Loader from '../shared/Loader';
import Meta from '../shared/Meta';

function DeletionStatus() {
  const { support_email } = useContext(ConfigContext);
  const location = useLocation();
  const params = RouteUtils.getQueryParams(location);

  const { data: response, isLoading } = useFetchDeletionStatusQuery({ id: params.id });
  const deletionStatus = response?.deletionStatus;

  return (
    <div>
      <Meta noindex />
      <div className='Box Box--white u-blockCenter u-limitWidth30 u-mt2'>
        <h2 className='u-mb2'>Data Deletion Status</h2>
        { deletionStatus &&
          <p>{ deletionStatus }</p>
        }
        { (isLoading || !deletionStatus) &&
          <div className='u-mb1'>
            <Loader/>
          </div>
        }
        <p>
          Questions? Email us at<br/>
          <a href={'mailto:' + support_email}>{support_email}</a>
        </p>
        <Link className='Button u-mt1' to='/'>
          Return Home
        </Link>
      </div>
    </div>
  );
}

export default DeletionStatus;
